jQuery(document).ready(function() {

  $("#modal_service").on("click", ".btn-activate", function(e) {
    $(this).find(".indicator-label").text("Activando...");
    $(this).css({
      "pointer-events": "none",
      "opacity": "0.65"
    });
  });

  // Manejar el clic en el switch para activar o desactivar el servicio
  $("#modal_service").on("click", "#confirmModalActivate, #confirmModalDeactivate", function(e){
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var serviceId = $(this).data('service-id');
    var serviceTitle = $(this).data('service-title');
    var clientId = $(this).data('client-id');
    var isActive = $(this).data('is-active');
    var switchElement = $(this);
    var activate = !isActive; // Determinar si se activará o desactivará el servicio

    // Mostrar confirmación según la acción a realizar
    Swal.fire({
      title: '¡Atención!',
      text: '¿Está seguro de ' + (activate ? 'activar' : 'desactivar') + ' ' + serviceTitle + '?',
      icon: 'warning',
      allowEscapeKey: false,
      allowEnterKey: false,
      buttonsStyling: false,
      allowOutsideClick: false,
      confirmButtonText: (activate ? 'Activar' : 'Desactivar'),
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      customClass: {
          confirmButton: "btn btn-fj-purple",
          cancelButton: "btn btn-light"
      }
    }).then((result) => {
        if (result.isConfirmed) {
          // Realizar la activación o desactivación del servicio
          performServiceAction(serviceId, clientId, AUTH_TOKEN, activate, switchElement);
        } else {
          // Si se cancela, revertir el cambio en el switch
          switchElement.prop("checked", !activate);
        }
    });
  });

  // Función para realizar la activación o desactivación del servicio
  function performServiceAction(serviceId, clientId, AUTH_TOKEN, activate, switchElement) {
    Swal.fire({
      title: 'Realizando acción...',
      text: "Por favor espere mientras se procesa la acción",
      icon: 'info',
      allowEscapeKey: false,
      allowEnterKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
    });
    // Consulta AJAX para activar o desactivar el servicio
    $.ajax({
      type: 'POST',
      url: '/admin/clientes/servicios/' + (activate ? 'activate' : 'deactivate') + '_hirint',
      dataType: 'script',
      data: {
        client_id: clientId,
        service_id: serviceId,
        authenticity_token: AUTH_TOKEN
      },
      success: function(response, textStatus, jqXHR) {
        // Actualizar el switch y el estado del servicio según la respuesta
        $('.switch-icon').removeClass('switch-light').addClass('switch-success');
        // Actualizar el estado del switch manualmente
        switchElement.data('is-active', activate);
        // Muestra mensaje de éxito
        Swal.fire({
          title: '¡Servicio ' + (activate ? 'Activado' : 'Desactivado') + '!',
          text: 'El servicio se ' + (activate ? 'activó' : 'desactivó') + ' correctamente.',
          icon: 'success',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-fj-purple",
          }
        });
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Muestra alerta indicando que hubo un error
        Swal.fire({
          text: 'Hubo un problema al ' + (activate ? 'activar' : 'desactivar') + ' el servicio. Por favor vuelve a intentar en unos minutos.',
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-fj-purple"
          }
        });
        // Si ocurrió un error, revertir el cambio en el switch
        switchElement.prop("checked", !activate);
      }
    });
  }




});
